// import { useState } from "react";
// import { toast } from "react-toastify";
// import { deleteUserApi } from "../../apis/userApi";

// export const useDeleteUser = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const deleteUser = async (userId) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Deleting user...");

//     try {
//       await deleteUserApi(userId);

//       toast.update(toastId, {
//         render: "User deleted successfully",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       return true;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.response?.data?.detail ||
//         err.data ||
//         "Failed to delete user.";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { deleteUser, loading, error };
// };

import { useState } from "react";
import { toast } from "react-toastify";
import { deleteUserApi } from "../../apis/userApi";

export const useDeleteUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to delete user.",
    };
  };

  const deleteUser = async (userId) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Deleting user...");

    try {
      await deleteUserApi(userId);

      toast.update(toastId, {
        render: (
          <div>
            <strong>User Deleted</strong>
            <div>User deleted successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return true;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { deleteUser, loading, error };
};